import { Box, Carousel } from '@stitch-fix/mode-react';
import { MODE_LEGACY_MIN_WIDTH } from '../../utils/values/mediaQueries';
import { type CloudinaryImageFields } from '../CloudinaryImageWrapper';
import { CloudinaryPicture } from '../CSCloudinaryAsset/Picture';
import { Header, type HeaderProps } from '../Header';
import styles from './style.module.scss';

export type WhatClothesCostProps = {
  images: {
    mobile: CloudinaryImageFields;
    desktop: CloudinaryImageFields;
  }[];
} & HeaderProps;

export const WhatClothesCost = ({
  images,
  title,
  description,
  descriptionLinks,
}: WhatClothesCostProps) => {
  return (
    <Box as="section" className={styles['what-clothes-cost']}>
      <Header
        title={title}
        description={description}
        descriptionLinks={descriptionLinks}
      />
      <Box className={styles.gallery}>
        <Carousel
          ariaLabel="Business Line Carousel"
          slideWidth={{ sm: '100%' }}
          gutterOverflow={{ sm: 0 }}
        >
          {images.map(image => (
            <Box key={image.mobile.src} className={styles.imageContainer}>
              <CloudinaryPicture
                alt={image.mobile.alt}
                sources={[
                  {
                    minWidth: 0,
                    cloudinaryAsset: image.mobile.cloudinaryAsset,
                  },
                  {
                    minWidth: MODE_LEGACY_MIN_WIDTH.sm,
                    cloudinaryAsset: image.desktop.cloudinaryAsset,
                  },
                ]}
                maxContainerWidth={885}
                imageProps={{
                  loading: 'lazy',
                }}
              />
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
};
